export const mentionSpec = {
  inline: true,
  attrs: {
    uri: {
      default: ''
    },
    name: {
      default: ''
    }
  },
  group: 'inline',
  selectable: true,
  parseDOM: [{
    tag: 'span.embercom-prosemirror-composer-mention',
    getAttrs(dom) {
      return {
        name: dom.innerText,
        uri: dom.getAttribute('data-uri')
      };
    }
  }],
  toDOM(node) {
    return ['span', {
      class: 'embercom-prosemirror-composer-mention',
      'data-uri': node.attrs.uri
    }, node.attrs.name];
  }
};